module.exports = __webpack_public_path__ + "static/payanyday_fav-b4f9db1774bc87d1d79e3ab06df5d512.png";